export class RefPersonal {

    model = {
        id: {value: null, export: false},
        idp: {value: null, export: false},
        nombres: {
            value: '', 
            export: false, 
            header: 'Nombres y Apellidos:', 
            required: 'Nombres y Apellidos es requerido',
            maxLength: 'Máximo 300 caracteres', 
            minLength: 'Mínimo 4 caracteres', 
            max: 300, 
            min: 4, 
            table: true, 
            filter: false, 
            sort: true
        },
        parentesco: {
            value: '', 
            export: true, 
            header: 'Parentesco:', 
            required: 'Parentesco es requerido', 
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 300, 
            min: 4, 
            table: true,
        },
        direccion: {
            value: '', 
            export: true, 
            header: 'Dirección:', 
            required: 'Dirección es requerido', 
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 300, 
            min: 4, 
            table: true,
        },
        telefono: {
            value: '', 
            export: true, 
            header: 'Teléfono de contacto:', 
            required: 'Teléfono es requerido', 
            maxLength: 'Máximo 20 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 50, 
            min: 4, 
            table: true,
        },
    }
}
